/**
 * Mock achievements service.
 * Mirrors the real achievements.service.js API with in-memory data.
 * Re-exports getAchievementDefinitions from the real service since it is pure.
 */
import { MOCK_ACHIEVEMENTS } from '../../data/mock/mock-accountability.data';
import { mockDelay, mockLog } from './mock-delay';

// Re-export from real service
export { getAchievementDefinitions } from '../achievements.service';

// In-memory state
let achievements = [...MOCK_ACHIEVEMENTS];

export const getAchievements = async (userId) => {
  mockLog('AchievementsService', 'getAchievements', userId);
  await mockDelay();
  return [...achievements];
};

export const checkAndAwardAchievements = async (userId, eventType, eventData = {}) => {
  mockLog('AchievementsService', 'checkAndAwardAchievements', { eventType, eventData });
  await mockDelay(50, 200);
  // In mock mode, never award new achievements (would need full definition matching)
  return [];
};

export const markAchievementSeen = async (userId, achievementId) => {
  mockLog('AchievementsService', 'markAchievementSeen', achievementId);
  await mockDelay(50, 150);
  const idx = achievements.findIndex((a) => a.id === achievementId);
  if (idx !== -1) achievements[idx] = { ...achievements[idx], seen: true };
};

export const getUnseenAchievements = async (userId) => {
  mockLog('AchievementsService', 'getUnseenAchievements', userId);
  await mockDelay();
  return achievements.filter((a) => !a.seen);
};
